module.exports = __webpack_public_path__ + "img/symmetry-neutral.498a3dee.svg";